export default "__VITE_ASSET__CWr_5SLn__"